import Vue from "vue";
import { callPutApi } from "@/utils/apiWrapper";
import UserAcConstant from "@/mixins/user/const/userAcConstant";
import { createContractTypeMigrator, migrationLock } from "@/utils/contractTypeMigration";

let migrate;
export const actions = {
  async acSyncContractType() {
    if (typeof window === "undefined") return false;
    if (!migrate) {
      migrate = createContractTypeMigrator({
        storage: {
          getItem: key => window.localStorage.getItem(key),
          removeItem: key => window.localStorage.removeItem(key),
        },
        put: (data, expectedToken) => callPutApi({ url: UserAcConstant.PUT_CONTRACT_TYPE, data, expectedToken }),
        track: properties => Vue.prototype.$mixpanel_track?.("View Sale Home-ContractType-Migration", properties),
        withLock: migrationLock,
      });
    }
    return migrate();
  },
};
export default { namespaced: true, actions };
